import React, {useContext, useState} from "react";
import "../../../../ui-styles/sliders/RightFullSlider.css";
import "../../../../ui-styles/profile/SlideProfileDetails.css";
import {LangCtx} from "../../../../lib/context";
import { getAge, getExperience } from "../../../../lib/functions";
import Rating from '@material-ui/lab/Rating';


const DoctorProfileSlide = React.forwardRef((props, ref) => {

    const { data } = props;
    const {l} = useContext(LangCtx);


    return (
        <div ref={ref} className={props.open ? "rightFullSlider rightSliderIn" : "rightFullSlider"}>
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>{l.profile}</span>
                    </div>
                    <div className="hdrActionGroup">
                        <div className="hdrActItem close" onClick={props.closeSlide}></div>
                    </div>
                </div>
            </div>
            <div className="rightSliderBdy">
                <div className="profileContainer">
                    <div className="profileTop">
                        <div className="profileAvtr">
                            <img src={data.profileImage && data.profileImage.url ? data.profileImage.url : "/images/icons/doctor-default.png"} alt="avatar" />
                        </div>
                        <h2 className="profileTxtL">{`Dr. ${data.firstName}`}</h2>
                        <span className="profileTxtL"><Rating name="read-only" precision={0.1}  value={data.ratings?.stars || 0} readOnly /></span>
                        <span className="profleSTxt">{data.qualification ? data.qualification : ""}
                            {data.department ? `(${data.department})` : ''}
                            {data.serviceStartDate ? `- ${getExperience(new Date(data.serviceStartDate))}` : ''}</span>
                            {/* <span className="profleSTxt">{findProperty('custom:qualification')}</span> */}
                        <span className="profleSTxt">{data.speciality ? data.speciality : ""}</span>
                        <span className="profleSTxt" style={{padding:'0 16px'}}>{data.summary}</span>
                        


                    </div>
                    <div className="profileDetails">
                        <div className="profileDtlHdr">
                            <span className="profileDtlTxt">{l.details}</span>
                        </div>
                        <div className="profileDtlGroup">
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.pat_gender}<small className="capitalizeTxt">{data.gender ? data.gender : ''}</small></span>
                            </div>
                            {/* <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_dob}<small>{data.dob ? dateFormat(data.dob) : ''}</small></span>
                            </div> */}
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.pat_age}<small>{data.dob ? getAge(new Date(data.dob)): ''}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_dept} :<small>{data.department ? data.department : ''}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.specialz} :<small>{data.speciality ? data.speciality : ''}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.Qualification}<small>{data.degree ? data.degree : ''}</small></span>
                            </div>
                        </div>

                        {/* <div className="profileDtlHdr">
                            <span className="profileDtlTxt">Contact Details</span>
                        </div>
                        <div className="profileDtlGroup">
                            <div className="profielDtlItem">
                        <span className="profileDtlTxt">{l.label_email}<small>{findProperty('email')}</small></span>
                            </div>
                            <div className="profielDtlItem">
                                <span className="profileDtlTxt">{l.label_phone_no}<small>{findProperty('custom:phone')}</small></span>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
});

export default DoctorProfileSlide;